module.exports = __webpack_public_path__ + "img/mainmenbuttonABD.1fe95038.png";